<template>
    <div>
        <div v-if="copy_address_label" class="row p-t-10 p-b-0" v-cloak>
            <div class="col-lg-3">
                <label>
                    <input name="is_copy_address" type="checkbox" class="m-1-10" v-model="is_copy_address"
                        @change="copyAddress">
                    {{ copy_address_label }}
                </label>
            </div>
        </div>

        <div class="row p-b-10">
            <div class="col-sm-3">
                <div class="fg-line form-group">
                    <label :for="field_prefix + 'address1'">Address 1</label>
                    <input type="text" :id="field_prefix + 'address1'" class="form-control"
                        v-model="address.address1" />
                </div>
            </div>
            <div class="col-sm-2">
                <div class="fg-line form-group">
                    <label :for="field_prefix + 'address2'">Address 2</label>
                    <input type="text" :id="field_prefix + 'address2'" class="form-control" placeholder="optional"
                        v-model="address.address2" />
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group fg-line">
                    <label :for="field_prefix + 'city'">City</label>
                    <input type="text" :id="field_prefix + 'city'" class="form-control" v-model="address.city" />
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group fg-line">
                    <label :for="field_prefix + 'state_cd'">State/Province</label>
                    <select :id="field_prefix + 'state_cd'" class="form-control" v-model="address.state_cd"
                        :class="{ disabled: filteredStates && filteredStates.length > 0 }">
                        <option v-for="state in filteredStates" :value="state.state_cd" v-html="state.state_nm">
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <div class="fg-line form-group">
                        <label :for="field_prefix + 'postal_cd'" class="text-nowrap">Postal Code</label>
                        <input type="text" :id="field_prefix + 'postal_cd'" class="form-control"
                            v-model="address.postal_cd" />
                    </div>
                </div>
            </div>

        </div>

        <div class="row p-b-10" style="position: relative;">
            <div class="col-sm-2">
                <div class="fg-line form-group">
                    <label>County</label>
                    <input type="text" :id="field_prefix + 'county'" class="form-control"
                        :placeholder="address.country_cd === 'US' ? '' : 'optional'" v-model="address.county" />
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group fg-line">
                    <label :for="field_prefix + 'country_cd'">Country</label>
                    <select :id="field_prefix + 'country_cd'" class="form-control" v-model=address.country_cd>
                        <option v-for="country in filteredCountries" :value="country.country_cd"
                            v-html="country.country_nm">
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-5 form-group m-t-25">
                <label class="cursor-pointer">
                    <input v-model="address.is_residential" type="checkbox"> Address is
                    Residential
                </label>
            </div>
        </div>

    </div>
</template>

<style lang="scss">
@import '../../../sass/global_variables';

input[name="is_residential"] {
    margin-right: 5px;
}
</style>

<script>
export default {
    props: {
        usa_only: { default: false },
        field_prefix: { default: '' },
        copy_address: { default: null },
        copy_address_label: '',
        initial_address: {}
    },

    data: function () {
        return {
            address: {
                address1: '',
                address2: '',
                city: '',
                state_cd: '',
                postal_cd: '',
                county: '',
                country_cd: 'US',
                is_residential: false,
            },
            countries: [{ country_cd: '', country_nm: 'Select Country' }],
            states: [{ state_cd: '', state_nm: 'Select State' }],
            addressControl: undefined,
            is_copy_address: false,
            addressY: {},
            result: {},
            is_loading: true,
        }
    },

    watch: {

        initial_address: {
            deep: true,
            handler() {
                let vm = this;
                if (this.is_loading) {
                    this.is_loading = false;
                    this.getCountries();
                    this.getStates(function () {

                        vm.address = Object.assign({}, vm.initial_address);
                        if (!vm.initial_address.country_cd) {
                            vm.address.country_cd = 'US';
                            vm.address.state_cd = '';
                        }
                    });

                }
            }
        },
        filteredStates: {
            handler() {
                if (this.filteredStates.length === 2) {
                    this.address.state_cd = this.filteredStates[1].state_cd;
                }
            }
        },

        address: {
            handler() {
                this.$emit('update', this.address);
            },
            deep: true
        },
    },
    computed: {
        filteredStates() {
            let vm = this;
            if (this.states) {
                return this.states.filter(function (state) {
                    return (state.country_cd === vm.address.country_cd || !state.country_cd)
                })
            } else {
                return null;
            }
        },
        filteredCountries() {
            if (this.usa_only) {
                this.address.country_cd = 'US';
                return this.countries.filter(function (item) {
                    return item.country_cd === 'US';
                })
            } else {
                return this.countries;
            }
        },
    },

    methods: {
        copyAddress() {
            if (this.is_copy_address) {
                this.address = Object.assign({}, this.copy_address);
            }
        },

        updateAddress() {
            this.$emit('update', this.address);
        },

        initializeAddressy() {
            let keyEl = document.getElementById('addressy-key');
            if (!keyEl) return;

            let key = keyEl.getAttribute('content');
            if (!key) return;

            let searchCountries = "US,AU,BM,BO,BR,BZ,CA,DE,FR,GB,GT,GU,IE,IN,JP,LK,MX,NL,NO,NZ,PK,PR,SE,TT,UAE,UK,ZA";
            let config = { key: key, bar: { visible: false }, search: { countries: searchCountries } };

            let fields = [
                { element: this.field_prefix + 'address1', field: 'Line1', mode: pca.fieldMode.SEARCH },
                { element: this.field_prefix + 'country_cd', field: 'CountryIso2', mode: pca.fieldMode.COUNTRY }
            ];

            this.addressControl = new pca.Address(fields, config);
            this.addressControl.listen('populate', this.selectedSearchedAddress);
        },

        selectedSearchedAddress(address, variations) {
            this.addressY = address;
            this.address = {
                address1: address.Line1,
                address2: address.Line2,
                city: address.City,
                state_cd: address.ProvinceCode,
                county: address.AdminAreaName,
                country_cd: address.CountryIso2,
                postal_cd: address.PostalCode,
                is_residential: address.Type === 'Residential' ? 1 : 0
            };
        },

        getCountries(success) {
            if (this.countries.length === 1) {
                let request = this.$http.get('/country-list');
                request.then(function (response) {
                    this.countries.splice(1, this.countries.length);
                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            this.countries.push(response.data[i]);
                        }
                    }
                    if (typeof success === 'function') success(response);
                });
            }
        },

        getStates(success) {

            if (this.usa_only && this.states.length === 1) {
                let request = this.$http.get('/states-list', { params: { country_cd: 'US' } });
                request.then(function (response) {

                    this.states.splice(1, this.states.length);

                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            this.states.push(response.data[i]);
                        }
                    }
                    if (typeof success === 'function') success(response);
                });
            } else if (this.states.length === 1) {
                let request = this.$http.get('/all-states');
                request.then(function (response) {
                    this.states.splice(1, this.states.length);

                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            this.states.push(response.data[i]);
                        }
                    }
                    if (typeof success === 'function') success(response);
                });
            }
        },
    },

    mounted: function () {

        this.initializeAddressy();
        let vm = this;
        if (this.countries.length === 1) {
            this.getCountries(function () {
                vm.getStates();
            });
        }
    }
}

</script>



// WEBPACK FOOTER //
// address-entry.vue?57ab1b1e